import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { Grid, Paper, Button } from '@material-ui/core';
import { CircularProgress, Typography, Divider } from '@material-ui/core';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';

import TextField from 'components/Form/TextField';
import TagList from './TagList/TagList';
import text from 'texts/translations';
import { Link } from 'react-router-dom';

import styles from '../App.css';
import componentStyles from './EditUser.css';
import { withSnackbar } from 'notistack';
import UserPriviligesSelect from '../../components/UserPrivilegesSelect/UserPriviligesSelect';
import Translation from '../../components/Translation/Translation';

@inject('customerCaseStore')
@inject('formDataStore')
@observer
class EditUser extends Component {
  constructor(props) {
    super(props);

    this.userId = props.match.params.id;

    this.state = {
      user: null
    }

    this.changeValue = this.changeValue.bind(this);
  }

  componentDidMount() {
    this.props.customerCaseStore.getUser(this.userId)
      .then(user => {
        this.setState({user});
      })
  }

  changeValue(key) {
    const deepUpdateObject = (obj, path, value) => {
      var keys = path.split('.');
      let current_path = keys.shift();

      if (keys.length > 0) {
        obj[current_path] = deepUpdateObject(obj[current_path], keys.join('.'), value);
      } else {
        obj[current_path] = value;
      }

      return obj;
    }

    return (event => {
      const value = event.target.value;

      let user = this.state.user;
      user = deepUpdateObject(user, key, event.target.value);

      this.setState({user});
    });
  }

  save() {
    this.props.customerCaseStore.updateUser(this.userId, this.state.user)
      .then((res) => {
        if (res.errors) throw res;
        this.props.enqueueSnackbar(<Translation>action.update_success</Translation>, {variant: 'success'})
      })
      .catch(() => this.props.enqueueSnackbar(<Translation>action.update_failed</Translation>, {variant: 'error'}));
  }

  remove() {
    this.props.customerCaseStore.removeUser(this.userId)
      .then((res) => {
        if (res.errors) throw res;
        this.props.enqueueSnackbar(<Translation>action.remove_success</Translation>, {variant: 'success'})
        this.props.history.push('/users');
      })
      .catch(() => this.props.enqueueSnackbar(<Translation>action.remove_failed</Translation>, {variant: 'error'}));
  }

  renderData() {
    if (!this.state.user)
      return;

    return (
      <Grid item xs={12}>
        <Grid item xs={12}>
          <TextField
            id="description"
            helperText={<Translation>username</Translation>}
            defaultValue={this.state.user.username}
            style={componentStyles.textField}
            disabled
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            id="description"
            helperText={<Translation>password</Translation>}
            type="password"
            defaultValue=""
            onChange={this.changeValue('password')}
            style={componentStyles.textField}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            id="description"
            helperText={<Translation>firstName</Translation>}
            defaultValue={this.state.user.userInformation.firstName}
            onChange={this.changeValue('userInformation.firstName')}
            style={componentStyles.textField}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            id="description"
            helperText={<Translation>lastName</Translation>}
            defaultValue={this.state.user.userInformation.lastName}
            onChange={this.changeValue('userInformation.lastName')}
            style={componentStyles.textField}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            id="description"
            helperText={<Translation>email</Translation>}
            type="email"
            defaultValue={this.state.user.userInformation.email}
            onChange={this.changeValue('userInformation.email')}
            style={componentStyles.textField}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            id="description"
            helperText={<Translation>jobTitle</Translation>}
            defaultValue={this.state.user.userInformation.jobTitle}
            onChange={this.changeValue('userInformation.jobTitle')}
            style={componentStyles.textField}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            id="description"
            helperText={<Translation>company</Translation>}
            defaultValue={this.state.user.userInformation.company}
            onChange={this.changeValue('userInformation.company')}
            style={componentStyles.textField}
          />
        </Grid>
        <Grid item xs={12} style={styles.marginBottom}>
          <UserPriviligesSelect
            helperText={<Translation>templateRightsLevel</Translation>}
            value={this.state.user.templateRightsLevel}
            onChange={this.changeValue('templateRightsLevel')}
            style={componentStyles.textField}
            />
        </Grid>
        <Button variant="raised" color="primary" onClick={this.save.bind(this)}>
          {<Translation>save</Translation>}
        </Button>

        {(() => {
          if (this.props.customerCaseStore.currentUser._id != this.userId) {
            return (
              <Button variant="raised" color="secondary" style={styles.floatRight} onClick={this.remove.bind(this)}>
                {<Translation>delete</Translation>}
              </Button>
            );
          }
        })()}
      </Grid>
    );
  }

  render() {
    return (
      <Grid item xs={12}>
        <Paper style={styles.paper}>{this.renderData()}</Paper>
      </Grid>
    );
  }
}

export default withSnackbar(EditUser);



// WEBPACK FOOTER //
// ./src/views/EditUser/EditUser.jsx